import React from 'react';
import { Routes, Route, Link, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AdminProducts from './AdminProducts';
import AddProduct from './AddProduct';
import AdminOrders from './AdminOrders';
import AdminVendors from './AdminVendors';
import AdminCultures from './AdminCultures';
import AdminCultureMedia from './AdminCultureMedia';
import AdminSettings from './AdminSettings';
import AdminUsers from './AdminUsers';
import './AdminDashboard.css';

function AdminDashboard() {
  const { isAdmin, logout } = useAuth();

  if (!isAdmin()) {
    return <Navigate to="/admin/login" />;
  }

  return (
    <div className="admin-dashboard">
      <nav className="admin-nav">
        <div className="container">
          <h2>Admin Dashboard</h2>
          <ul>
            <li><Link to="/admin/dashboard/products">Products</Link></li>
            <li><Link to="/admin/dashboard/orders">Orders</Link></li>
            <li><Link to="/admin/dashboard/users">Customers</Link></li>
            <li><Link to="/admin/dashboard/vendors">Vendor Applications</Link></li>
            <li><Link to="/admin/dashboard/cultures">Cultural Info</Link></li>
            <li><Link to="/admin/dashboard/settings">Settings</Link></li>
            <li><button onClick={logout} className="logout-btn">Logout</button></li>
          </ul>
        </div>
      </nav>

      <div className="admin-content container">
        <Routes>
          <Route index element={<AdminProducts />} />
          <Route path="products" element={<AdminProducts />} />
          <Route path="products/new" element={<AddProduct />} />
          <Route path="orders" element={<AdminOrders />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="vendors" element={<AdminVendors />} />
          <Route path="cultures" element={<AdminCultures />} />
          <Route path="cultures/media/:id" element={<AdminCultureMedia />} />
          <Route path="settings" element={<AdminSettings />} />
        </Routes>
      </div>
    </div>
  );
}

export default AdminDashboard;
